import * as React from 'react';
import { OpenApiDoMain } from '@src/constants'
import Item from '@component/Item'
import Header from '@component/Header'
import Bottom from '@component/Bottom'
import './style.scss'
import axios from 'axios'

const pageSize = 10
interface INewsState {
  itemList: any,
  current: number,
  currentPage: number,
  totalPage: number
}

export default class News extends React.Component<any, INewsState> {
  constructor(props: any) {
    super(props)
    this.state = {
      itemList: [],
      currentPage: 1,
      current: 1,
      totalPage: 1
    }
  }

  public componentDidMount() {
    this.getList(1)
  }

  public getList(currentPage: number) {
    const that = this
    axios.get(OpenApiDoMain + '/article?pageSize=' + pageSize + '&currentPage=' + currentPage + '&channel=yuqinet.com&hot=&tag=')
      .then((res) => {
        console.log(res.data);
        console.log(Math.ceil(res.data.count / pageSize));
        that.setState({
          itemList: res.data.data,
          currentPage: res.data.currentPage,
          totalPage: Math.ceil(res.data.count / pageSize)
        });
      })
  }


  public paginationHandler(status: string) {
    if (status === 'previous' && this.state.current !== 1) {
      const tmpCurrent = this.state.current - 1 < 0 ? 0 : this.state.current - 1
      this.setState({ current: tmpCurrent })
      this.getList(tmpCurrent);
    }
    if (status === 'next' && this.state.current !== this.state.totalPage) {
      const tmpCurrent = this.state.current + 1 > this.state.totalPage ? this.state.totalPage : this.state.current + 1
      this.setState({ current: tmpCurrent })
      this.getList(tmpCurrent);
    }
  }


  public render() {
    return (
      <div className="pc-news">
        <Header />
        <div className="news-first-content"><div>我们在做什么</div></div>
        <div className="item-list">
          {this.state.itemList.map((item: any, key: number) => {
            return <Item key={key} index={item.id} item={item} pc={true} />
          })}

        </div>
        {this.state.totalPage > 1
          ? (<div className="two-button"><div onClick={this.paginationHandler.bind(this, 'previous')}>上一页</div>
            <div onClick={this.paginationHandler.bind(this, 'next')}>下一页</div> </div>)
          : ''
        }
        <Bottom />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/News/index.tsx